import { AppHelper } from "../appHelper"
import { CommonApp } from "../core/components/commonApp";
import React from "react";

export default class ServerProtokollApp extends React.Component<any, any> {
    common = new AppHelper();
    setTabTitle = true;


    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }
    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
};
